import { URLConstructor } from '../../NonReact/utils/URLBuilder'
import { getAppV2APIBasePath } from '../../NonReact/constants/ApiConstants'
import { RouteID } from '../Components/Molecules/Header/Types/Types'

export const routePath = (routeID: RouteID): string => `/${routeID}`
export const routeURL = (routeID: RouteID): URLConstructor => getAppV2APIBasePath().appendPathParams(routeID)

export const AUTH_ROUTE_PATH: string = routePath(RouteID.AUTH)
export const CHANGE_PASSWORD_ROUTE_PATH: string = routePath(RouteID.CHANGE_PASSWORD)
export const MFA_ROUTE_PATH: string = routePath(RouteID.MFA)
export const TERMS_AND_CONDITIONS_ROUTE_PATH: string = routePath(RouteID.TERMS_AND_CONDITIONS)
export const TEAMS_AUTH_ROUTE_PATH: string = routePath(RouteID.TEAMS_AUTH)
export const INSIGHTS_HUB_ROUTE_PATH: string = routePath(RouteID.INSIGHTS)
export const ADMIN_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.ADMIN)
export const STATUS_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.STATUS)
export const LICENCES_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.LICENCES)
export const LICENCE_MANAGEMENT_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(
    RouteID.LICENCE_MANAGEMENT
)
export const TELSYS_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.TELSYS)
export const USERS_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.USERS)
export const CME_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.CME)
export const AGENT_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.AGENT)
export const PARTITION_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.PARTITION)
export const DEVICE_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.DEVICE)
export const CODE_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.CODE)
export const RECORDING_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.RECORDING)
export const MESSAGES_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.MESSAGES)
export const DATABASE_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.DATABASE)
export const DIRECTORY_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.DIRECTORY)
export const INSIGHTS_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.INSIGHTS)
export const CRM_INTEGRATION_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(
    RouteID.CRM_INTEGRATION
)
export const CLIENT_CONFIGURATION_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(
    RouteID.CLIENT_CONFIGURATION
)
export const PRESENCE_URL: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.PRESENCE)

export const CX_SCORE_URL: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.CXSCORE)

export const AUDIT_TRAIL_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.AUDIT_TRAIL)

export const LOG_MANAGEMENT_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.LOG_MANAGEMENT)

export const LOGGING_SETTINGS_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(
    RouteID.LOGGING_SETTINGS
)

export const TEL_MODULE_STATUS_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(
    RouteID.TEL_MODULE_STATUS
)

export const CALL_CONTROL_URL: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.ADMIN_CONTROL)
export const getAuthURL = (): URLConstructor => getAppV2APIBasePath().appendPathParams(RouteID.AUTH)

export const getChangeLanguageURL = (): URLConstructor =>
    getAppV2APIBasePath().appendPathParams(RouteID.CHANGE_LANGUAGE)

export const getChangePasswordURL = (): URLConstructor =>
    getAppV2APIBasePath().appendPathParams(RouteID.CHANGE_PASSWORD)

export const termsAndConditionsURL = (): URLConstructor =>
    getAppV2APIBasePath().appendPathParams(RouteID.TERMS_AND_CONDITIONS)

export const cookiePolicyURL = (): URLConstructor => getAppV2APIBasePath().appendPathParams(RouteID.COOKIE_POLICY)

export const privacyPolicyURL = (): URLConstructor => getAppV2APIBasePath().appendPathParams(RouteID.PRIVACY_POLICY)
